module.exports = __webpack_public_path__ + "img/product_29.2a5b2c4.svg";